import "../../styles/components/ErrorLocation.css";
import { Button, Modal } from 'antd';
import React, { useState } from 'react';
import IConfirmLocation from '../../components/icons/iConfirmLocation'
import BButton from "../../components/general/BButton";
import helper from "../../utils/helper";
const ConfrimWorkInOut = ({ type, workInOutData, isModalOpen = false, onOK, onCancel, isLoading }) => {
  const handleOk = () => {
    onOK()
  };
  const handleCancel = () => {
    onCancel()
  };
  return (
    <>
      <Modal
        wrapClassName="modal-confirm-shift"
        open={isModalOpen}
        closable={false}
        onOk={handleOk} 
        maskClosable={false}
        footer={[]}
      >
        <div className="confirm-shift">
            <div className="icon"><IConfirmLocation/></div>
            <h4>คุณแน่ใจหรือไม่</h4>
            { type === 'WORKOUT'
              ?<div className="info-confirm">คุณต้องการออกงานของเวรทำงาน</div>
              :<div className="info-confirm">คุณต้องการเข้างานของเวรทำงาน</div>
            }
            
            <div className="info-confirm">
              วันที่ {helper.FN.toDateFullThai(workInOutData.workShiftSchedule?.date)} 
              เวลา {helper.FN.toTimeHM(workInOutData.workShiftSchedule?.shiftTimeFrom)} - {helper.FN.toTimeHM(workInOutData.workShiftSchedule?.shiftTimeTo)} น. ({helper.FN.numberToshift(workInOutData.workShiftSchedule?.shift)})</div>
            <div className="info-shift">{workInOutData.workShiftSchedule?.ward?.hospital?.hospitalName} : {workInOutData.workShiftSchedule?.ward?.wardName}</div>
        </div>
        <div className="footer-confirm-shift">
        <BButton setStyle="outline confirm" onClick={handleCancel}>ยกเลิก</BButton>
          <BButton setStyle="confirm" onClick={handleOk} disable={isLoading}>ยืนยัน</BButton>
        </div>
      </Modal>
    </>
  );
};
export default ConfrimWorkInOut;